import { ArrowSmallRightIcon } from '@heroicons/react/20/solid';
import { PresetView } from 'pages/Shipments/Containers/types';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useCountFromAPI } from '../hooks';

interface Props {
  title: React.ReactNode;
  presetView: PresetView;
}

export const CountCard: React.FC<Props> = (props) => {
  const { presetView, title } = props;

  const { inner, preset, handleClick } = useCountFromAPI(presetView);

  return (
    <Link
      to={preset.to}
      onClick={handleClick}
      className="group flex flex-col py-2 pl-4 gap-0.5 hover:bg-gray-100 transition-colors"
    >
      <div className="flex items-center gap-1">
        <div className="truncate text-xs font-medium text-gray-500">{title}</div>
        <ArrowSmallRightIcon className="h-4 w-4 text-gray-700 group-hover:text-blue-900 transition-colors" />
      </div>
      <h6 className="font-bold text-sm text-gray-900">{inner}</h6>
    </Link>
  );
};
CountCard.displayName = 'CountCard';
